module.exports = __webpack_public_path__ + "img/tournaments.f7de553c.svg";